import { connect } from "react-redux";
import Tree from "../../components/Journal/Tree";
import { selectPage } from "../../actions/journal";

const mapStateToProps = state => {
  const { selectedPage } = state.journal;
  return {
    selected: selectedPage,
    title: "Journal"
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectPage: page => {
      dispatch(selectPage(page));
    }
  };
};

const JournalTree = connect(mapStateToProps, mapDispatchToProps)(Tree);

export default JournalTree;
